<template>
    <component :is="modeComponent"/>
</template>

<script>
    import ModeSwitcher from '@csp-app/lib/ModeSwitcher';

    export default {
        data() {
            return {
                modeComponent: (new ModeSwitcher()).getModeComponent(),
            }
        },
    }
</script>
